<template>
    <ElementLayout :parent="parent" :element="element">
        <v-select v-model="element.value" :items="options" @change="fieldChanged" :label="element.title" :disabled="element.disabled" :hide-details="true" :single-line="false" />
    </ElementLayout>
</template>

<script>
import ElementLayout from '../ElementLayout' 
import ScreenHelpers from '@/screens/ScreenHelpers' 

export default {
    data() {
        return {
            // value: null,
            // originalValue: null,
        }
    },

    components: {
        ElementLayout,
    },
    
    props: {
        element: Object,
        parent: Object,
    },

    computed: {
        options() {
           return ScreenHelpers.parseOptions(this.element.options)
        },
    },

    methods: {
        fieldChanged(newVal) {
            this.$emit('change', newVal, this.originalValue)
            this.originalValue = newVal
        },
    },
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// DropdownControl.vue?2312b52c